import { Profile } from "./elements/Profile";
import { NavbarButtons } from "./elements/NavbarButtons";
import { NavbarContainer } from "./elements/NavbarContainer";
import styled from "@emotion/styled";
import { NavbarLinksTablet } from "./elements/NavbarLinksTablet";
import { useDisplayOnClick } from "hooks/useDisplayOnClick";

export const NavbarV2Tablet = () => {
  const {
    isDisplayed: isProfileActionsDisplayed,
    toggleDisplay: onProfileClick,
    elementToClickRef: profileButtonRef,
    elementToDisplayRef: profileActionsRef,
    forceClose: closeProfileActions,
  } = useDisplayOnClick();

  return (
    <NavbarContainer>
      <div>
        <Profile
          isDisplayed={isProfileActionsDisplayed}
          elementToClickRef={profileButtonRef as React.Ref<HTMLDivElement>}
          elementToDisplayRef={profileActionsRef as React.Ref<HTMLDivElement>}
          closeDisplay={closeProfileActions}
          onClick={onProfileClick}
        />

        <LinksContainer>
          <NavbarButtons />
          <NavbarLinksTablet />
        </LinksContainer>
      </div>
    </NavbarContainer>
  );
};

// Sub-components

const LinksContainer = styled.div`
  margin-top: 76px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
`;
